import { Injectable } from '@angular/core';
import { select, Store } from '@ngrx/store';
import * as SystemActions from './system.actions';
import * as fromSystem from './system.reducer';
import * as SystemSelectors from './system.selectors';

@Injectable({
  providedIn: 'root',
})
export class SystemFacade {
  tenantConfig$ = this.store.pipe(select(SystemSelectors.selectTenantConfig));

  constructor(private store: Store<fromSystem.State>) {}

  getTenantConfig() {
    this.store.dispatch(SystemActions.getTenantConfig());
  }
}
